export default "__VITE_ASSET__C_AixPGK__"